module.exports = "<div class=\"switch flex\" ng-class=\"{'left': !model, 'right': model}\" ng-click=\"toggle()\">\n    <div class=\"switch-circle\"></div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./scripts/core/directives/views/switch.html
// module id = 306
// module chunks = 0